import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { Fragment } from 'react';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
import { getProfessionalPlanData } from './utils';
export const shouldRender = (data, isExcludedUrl = false) => {
    const { isTrialing, trialEndDate } = data.currentAccount;
    return !!isTrialing && !!trialEndDate && !isExcludedUrl;
};
export const Component = function ProfessionalTrialing(props) {
    const { data, currency } = props;
    const { currentAccount, possiblePlans } = data;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { trialEndDate } = currentAccount;
    const trialDaysRemaining = daysFromNow(trialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const { professionalUpgradeUrl, professionalPlanAmount, } = getProfessionalPlanData(possiblePlans, currentAccount);
    const upgradeUrl = professionalUpgradeUrl;
    const nextPlanAmount = professionalPlanAmount;
    const onClickLink = () => {
        props.trackEvent('Trial: clicked banner');
    };
    return (isolateComponent(Alert, { layout: props.layout, title: "Welcome to your Professional trial!", type: "info" },
        isolateComponent("p", null,
            `You have ${trialDaysRemaining} ${daysText} to try Zapier’s `,
            isolateComponent(Link, { href: getFullyQualifiedURL('/help/account/billing-pricing/understand-your-zapier-premium-trial'), onClick: onClickLink }, "paid features"),
            ".",
            ' ',
            isolateComponent(Fragment, null,
                isolateComponent(Link, { href: upgradeUrl, onClick: onClickLink }, "Upgrade"),
                ' ',
                "anytime",
                nextPlanAmount > 0 && (isolateComponent("span", null,
                    ' ',
                    "for as low as ",
                    isolateComponent(Price, { currency: currency }, nextPlanAmount),
                    "/month."))))));
};
//# sourceMappingURL=ProfessionalTrialing.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
